import React from "react";
import { motion } from "framer-motion";

function Dialog(props) {
  return (
    <motion.div
      className="w-100 h-100 flex absolute top-0 left-0 z-5 items-center justify-center bg-custom-dark-transparent"
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: 'easeOut', duration: 0.2 }}
    >
      <div className="pa3 br2 bg-white shadow-2 flex flex-column items-center">
        <p className="mb0 f4">{props.i18n['restart_game_question']}</p>
        <p>{props.i18n['you_will_lose_progress']}</p>
        <div>
          <button
            className="mr2"
            onClick={() => {
              props.resetGame();
            }}
          >
            {props.i18n['yes']}
          </button>
          <button
            onClick={() => {
              props.hideDialog();
            }}
          >
            {props.i18n['no']}
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default Dialog;
